
angular.module('bl.backbutton').directive('blBackButton', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: blBackButtonController
    };
});

function blBackButtonController($scope, $attrs, $rootScope) {
    $scope.backButtonClick = () => {
        let parentScope = $scope.$parent.$parent.$parent;
        if ($scope.selected_tickets) {
            let itemsToRemove = $scope.current_ticket_items;
            itemsToRemove.forEach(item => {
                console.log(`Removing ${item.id}`);
                parentScope.deleteBasketItem(item);
            });

            parentScope.setBasket(parentScope.basket);

            $rootScope.$broadcast('basket:updated', parentScope.basket);
            $rootScope.$broadcast('basket-items', parentScope.basket);
            // settimeout 1 second
            setTimeout(() => {
                parentScope.loadPreviousStep();
            }, 1000);
        } else {
            parentScope.decideNextPage('templates/public-booking/steps/event_details');
        }
    };
}


// WEBPACK FOOTER //
// ../src/public/javascripts/event-back-button/event_back_button.directive.js